import { useMemo } from 'react';

import { useSelector } from 'src/store/react';
import {
  createBatchJobLinkSolReferenceSelector,
  createJobLinkSolReferenceSelector,
} from 'src/store/results';

const useSolMetadataReference = (
  props: Parameters<typeof createJobLinkSolReferenceSelector>[0],
) => {
  const selectSolMetadataReference = useMemo(
    () => createJobLinkSolReferenceSelector(props),
    [props],
  );

  const solMetadataReference = useSelector(selectSolMetadataReference);

  return solMetadataReference;
};

export const useBatchSolMetadataReference = (
  props?: Array<Parameters<typeof createJobLinkSolReferenceSelector>[0]>,
) => {
  const selectBatchSolMetadataReference = useMemo(
    () => createBatchJobLinkSolReferenceSelector(props),
    [props],
  );

  return useSelector(selectBatchSolMetadataReference);
};

export default useSolMetadataReference;
